import { Expose, Type } from "class-transformer";
import { EventRole } from "@/models/enums/event_role";
import { EventType } from "@/models/enums/event_type";
import { AddressModel } from "../address";
import { EventPlanModel } from "./event_plan";


export class EventListModel {
  constructor() {
    this.eventId = 0;
    this.orderNumber = "";
    this.eventName = "";
    this.eventStatus = "";
    this.eventStatusCode = "";
    this.eventStatusGroup = 1;
    this.startInstallDate = "";
    this.endInstallDate = "";
    this.customerEventId = null;
    this.eventType = EventType.EVENT;
    this.eventRole = EventRole.SALE;
    this.eventOwnerName = "";
  }

  @Expose({ name: "eventId" })
  eventId: number;

  @Expose({ name: "orderNumber" })
  orderNumber: string;

  @Expose({ name: "eventName" })
  eventName: string;

  @Expose({ name: "eventStatus" })
  eventStatus: string;

  @Expose({ name: "eventStatusCode" })
  eventStatusCode: string;

  @Expose({ name: "eventStatusGroup" })
  eventStatusGroup: number;

  @Expose({ name: "startInstallDate" })
  startInstallDate: string;

  @Expose({ name: "endInstallDate" })
  endInstallDate: string;

  @Expose({ name: "customerEventId" })
  customerEventId: number | null;

  @Expose({ name: "plan" })
  @Type(() => EventPlanModel)
  plan?: EventPlanModel;

  @Expose({ name: "eventType" })
  eventType: EventType;

  @Expose({ name: "eventRole" })
  eventRole: EventRole;

  @Expose({ name: "eventOwnerName" })
  eventOwnerName: string;

  @Expose({ name: "shiptoAddress" })
  @Type(() => AddressModel)
  shiptoAddress?: AddressModel;

}
